import { render, staticRenderFns } from "./map.vue?vue&type=template&id=2fc8a58b&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc8a58b')) {
      api.createRecord('2fc8a58b', component.options)
    } else {
      api.reload('2fc8a58b', component.options)
    }
    module.hot.accept("./map.vue?vue&type=template&id=2fc8a58b&", function () {
      api.rerender('2fc8a58b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/map.vue"
export default component.exports